<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">资格审查</h2>
            </div>
        </div>

        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm">
                <el-form-item label="标段名称">
                    <el-input v-model="searchForm.bidSectionName" placeholder="请输入标段名称" clearable
                        style="width: 300px;" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="display: flex; align-items: center;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>

            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="bidSectionCode" label="标段编码" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column label="详细信息" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleSetQualification(scope.row)"
                            class="action-btn">
                            {{ scope.row.status === 0 ? '审核' : '查看' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 弹窗 -->
        <el-dialog title="资格审查" :visible.sync="dialogVisible" width="80%" :append-to-body="true">
            <el-table :data="reviewList" border v-loading="dialogLoading">
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="stepName" label="步骤名称" show-overflow-tooltip />
                <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="handleStartReview(scope.row)">{{ scope.row.completed == 1 ? '继续审查' : '开始审查' }}</el-button>
                        <!-- 资格审查结果 -->
                        <el-button type="primary" size="small" @click="handleReviewResult(scope.row)"  v-if="scope.row.completed == 1">资格审查结果</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
        <!--评审 -->
        <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" size="100%">
            <div class="drawer-content">
                <div class="top-navbar">
                    <div class="navbar-left">
                        <el-select v-model="selectedBidder" placeholder="请选择投标单位" @change="handleBidderChange">
                            <el-option v-for="item in bidderOptions" :key="item.userId" :label="item.userName"
                                :value="item.userId">
                            </el-option>
                        </el-select>
                        <el-button type="warning" @click="openAttachmentViewByUserId(selectedBidder)"
                            style="margin-left: 10px;">附件查看</el-button>
                    </div>
                    <el-button type="primary" @click="handleReviewEffective">统一评审</el-button>

                    <el-button type="danger" @click="handleClose">关闭</el-button>
                </div>
                <div style="display: flex; flex: 1; height: 100%;">
                    <!-- pdf区域 -->
                    <div style="flex: 1;">
                        <PdfViewer :pdf-url="pdfUrl" :show-toolbar="true" :initial-scale="1"  @verify-seal="handleVerifySeal" />
                    </div>
                    <!-- 评审区域 -->
                    <div class="review-area">
                            <div class="qualification-review">
                                <div class="review-fixed-section">
                                    <div class="unit-selection">
                                        <div class="selection-title">评审项</div>
                                        <div class="unit-select-custom" v-click-outside="() => unitSelectOpen = false">
                                            <div class="usc-trigger" :class="{ 'is-open': unitSelectOpen }"
                                                @click.stop="unitSelectOpen = !unitSelectOpen">
                                                <span v-if="selectedUnitLabel" class="usc-value">{{ selectedUnitLabel }}</span>
                                                <span v-else class="usc-placeholder">请选择评审项</span>
                                                <i class="el-icon-arrow-down usc-arrow"
                                                    :class="{ 'is-open': unitSelectOpen }"></i>
                                            </div>
                                            <div v-show="unitSelectOpen" class="usc-dropdown">
                                                <div v-for="(unit, index) in unitOptions" :key="unit.id" class="usc-option"
                                                    :class="{ 'is-selected': selectedUnit === unit.id }"
                                                    @click.stop="selectUnit(unit, index)">
                                                    {{ index + 1 }}、{{ unit.reviewName }}
                                                </div>
                                                <div v-if="!unitOptions.length" class="usc-empty">无数据</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="review-standard-box">
                                        <div class="review-standard-title">评审标准:</div>
                                        <div class="review-standard-content">{{ reviewStandard }}</div>
                                    </div>
                                </div>
                                <!-- 评审项列表 -->
                                <div class="review-scroll-section">
                                    <div class="review-item" v-for="(item, index) in recordInfo.userItems" :key="item.userId">
                                        <div class="review-item-header">
                                            <span class="item-label">{{ index + 1 }}、{{ item.userName }}</span>
                                        </div>
                                        <div class="review-options">
                                            <el-radio-group v-model="item.isPass" :disabled="evaluationStatus == 2"
                                                @change="handleIsPassChange(item)">
                                                <el-radio :label="1">
                                                    <span class="radio-label">√</span>
                                                </el-radio>
                                                <el-radio :label="0">
                                                    <span class="radio-label">×</span>
                                                </el-radio>
                                            </el-radio-group>
                                        </div>
                                        <div class="comment-area" v-if="item.isPass === 0">
                                            <el-input v-model="item.notPassReason" type="textarea" :rows="4"
                                                placeholder="请输入评审意见..." resize="vertical"
                                                :disabled="evaluationStatus == 2"
                                                @input="handleNotPassReasonInput(item)"></el-input>
                                        </div>
                                    </div>
                                </div>

                                <!-- 操作按钮 -->
                                <div class="action-buttons">
                                    <el-button type="warning" @click="handleOneClickPass"
                                        :disabled="evaluationStatus == 2">一键通过</el-button>
                                    <el-button type="primary" v-if="previous != 0" @click="handleStepItemNavigate(previous)"
                                        :disabled="evaluationStatus == 2">上一项</el-button>
                                    <el-button type="success" @click="handleStepItemNavigate(next)" v-if="next != 0"
                                        :disabled="evaluationStatus == 2">下一项</el-button>
                                    <el-button type="danger" v-if="next == 0 && selectedUnit" @click="submit"
                                        :disabled="evaluationStatus == 2">提交</el-button>
                                </div>
                            </div>
                    </div>
                </div>

            </div>
        </el-drawer>

        <!-- 评审生效弹窗 -->
        <el-dialog title="" :visible.sync="reviewEffectiveDialogVisible" width="100%" height="100%"
            :before-close="handleReviewEffectiveDialogClose" class="review-effective-dialog" :modal="true"
            :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="review-effective-content">
                <div class="review-effective-header">
                    <div class="header-left">
                        <h1 class="review-title">统一评审</h1>
                        <div class="review-effective-subtitle">统一核对各投标单位评审结果，确认后提交生效</div>
                    </div>
                    <div class="header-right">
                        <el-button type="primary" class="one-click-pass-btn" @click="handleOneClickPassInDialog"
                            :disabled="evaluationStatus == 2">一键通过</el-button>
                        <el-button type="primary" class="close-btn" @click="handleReviewEffectiveDialogClose">关闭</el-button>
                        <el-button type="primary" class="submit-effective-btn" @click="handleSubmitEffective"
                            :disabled="evaluationStatus == 2">提交生效</el-button>
                    </div>
                </div>

                <div class="review-table-container">
                    <el-table :data="reviewEffectiveTableData" border style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                        :cell-style="{ color: '#303133' }" class="review-effective-table">
                        <el-table-column v-for="col in reviewEffectiveTitles" :key="col.itemKey" :prop="col.itemKey"
                            :label="col.itemKey === '0' ? '投标公司' : col.title" min-width="140" align="center">
                            <template slot-scope="scope">
                                <span v-if="col.itemKey === '0'">
                                    <div class="effective-unit-cell">
                                        <span class="unit-name">{{ scope.row._userName }}</span>
                                    </div>
                                </span>
                                <template v-else>
                                    <div>
                                        <el-radio-group v-model="scope.row[col.itemKey]" :disabled="evaluationStatus == 2"
                                            @change="handleEffectiveIsPassChange(scope.row, col)" class="effective-radio-group">
                                            <el-radio label="1">√</el-radio>
                                            <el-radio label="0">×</el-radio>
                                        </el-radio-group>
                                        <div class="cell-comment" v-if="scope.row[col.itemKey] === '0'">
                                            <el-input v-model="scope.row[col.itemKey + '_notPassReason']" type="textarea" :rows="3"
                                                placeholder="请输入评审意见..." resize="vertical" :disabled="evaluationStatus == 2"
                                                class="effective-reason-input" @input="handleEffectiveReasonInput(scope.row, col)" />
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="effective-review-standard" v-if="effectiveReviewStandard">
                        <div class="effective-review-standard-title">当前评审标准</div>
                        <div class="effective-review-standard-content">{{ effectiveReviewStandard }}</div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 附件查看弹窗 -->
        <el-dialog title="附件" :visible.sync="attachmentViewDialogVisible" width="600px">
            <el-table :data="attachmentViewList" border style="width: 100%"
                :header-cell-style="{ backgroundColor: '#f5f7fa', fontWeight: 'bold' }">
                <el-table-column prop="fileName" label="文件名称(点击下载)" min-width="260">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.fileName" type="primary" @click="handleFileDownload(scope.row)" class="file-link">
                            {{ scope.row.fileName }}
                        </el-link>
                        <span v-else class="no-data">暂无数据</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fileExtension" label="文件类型" width="120" align="center"></el-table-column>
                <el-table-column prop="fileSize" label="文件大小" width="120" align="center"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleFileDownload(scope.row)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="attachmentViewDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 资格审查结果弹窗 -->
        <el-dialog title="资格审查结果" :visible.sync="reviewResultDialogVisible" width="100%"
            :before-close="handleReviewResultDialogClose" class="review-result-dialog"
            :close-on-click-modal="false" :close-on-press-escape="false" top="2vh">
            <div class="review-result-content">
                <div class="review-result-header">
                    <div class="header-left">
                        <h1 class="review-result-title">资格审查结果</h1>
                        <div class="review-result-subtitle">汇总各投标单位评审结果，可用于打印存档</div>
                    </div>
                    <div class="header-right">
                        <el-button type="primary" icon="el-icon-printer" class="print-btn"
                            @click="handlePrintReviewResult">打印</el-button>
                        <el-button type="primary" class="close-btn"
                            @click="handleReviewResultDialogClose">关闭</el-button>
                    </div>
                </div>
                <div id="review-result-print-area" class="review-result-print-area">
                    <div class="print-header">
                        <h1>资格审查结果汇总表</h1>
                        <div class="info">
                            <div><span class="label">项目名称：</span><span>{{ projectTitle }}</span></div>
                            <div><span class="label">标段名称：</span><span>{{ reviewResultBidSectionName }}</span></div>
                        </div>
                    </div>
                    <el-table :data="reviewResultTableData" border style="width: 100%"
                        v-loading="reviewResultLoading"
                        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                        :cell-style="{ color: '#303133' }" class="review-result-table">
                        <el-table-column type="index" label="序号" width="60" align="center" fixed="left" />
                        <el-table-column prop="_reviewTitle" label="评审项" min-width="220" align="center" fixed="left">
                            <template slot-scope="scope">
                                <div class="result-review-cell">
                                    <span class="review-name">{{ scope.row._reviewTitle }}</span>
                                    <div class="review-standard-text" v-if="scope.row._reviewStandard">
                                        {{ scope.row._reviewStandard }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="bidder in reviewResultBidders" :key="bidder.userId"
                            :label="bidder.userName" min-width="160" align="center">
                            <template slot-scope="scope">
                                <div class="result-cell">
                                    <span class="result-mark"
                                        :class="(scope.row[bidder.userId] === '1' || scope.row[bidder.userId] === 1) ? 'pass' : 'fail'">
                                        {{ (scope.row[bidder.userId] === '1' || scope.row[bidder.userId] === 1) ? '√' : (scope.row[bidder.userId] === '0' || scope.row[bidder.userId] === 0 ? '×' : '-') }}
                                    </span>
                                    <div class="cell-comment"
                                        v-if="scope.row[bidder.userId + '_notPassReason']">
                                        {{ scope.row[bidder.userId + '_notPassReason'] }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { qualificationReviewList } from '@/api/modules/qualificationReview'
import { getAgentReview } from '@/api/modules/evaluation'
import { getBidderList, getBidderFile, getQualificationRecordInfo, saveQualificationRecordPassPer, submitQualificationRecord, getQualificationRecordInfoList, saveQualificationRecordPassAll, getBidderAttachment } from '@/api/modules/evaluation'
import { getStepDetailByStepId } from '@/api/modules/evaluationstep';
import PdfViewer from '@/components/common/PdfViewer.vue'
export default {
    components: {
        PdfViewer
    },
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            sectionCode: '',
            projectTitle: '',
            loading: false,
            dialogVisible: false,
            dialogLoading: false,
            reviewList: [],
            unitOptions: [],
            searchForm: {
                bidSectionName: ''
            },
            drawer: false,
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            selectedBidder: '',
            bidderOptions: [],
            pdfUrl: '',
            selectedUnit: '',
            reviewStandard: '',
            nodeName: '',
            unitSelectOpen: false,
            stepId: '',
            orderNum: '',
            recordInfo: {},
            evaluationStatus: null,
            previous: 0,
            next: 0,
            stepTypeCode: '01',
            qualificationRecordInfoList: [],
            // 弹窗控制
            reviewEffectiveDialogVisible: false,
            // 评审生效表格数据
            reviewEffectiveTitles: [],
            reviewEffectiveTableData: [],
            effectiveReviewStandard: '',
            effectiveActiveColumnKey: '',
            effectiveActiveItemId: '',
            // 通过式自动保存防抖定时器
            _notPassDebounceTimer: null,
            _effectiveDebounceTimer: null,
            // 附件查看弹窗
            attachmentViewDialogVisible: false,
            attachmentViewList: [],
            // 资格审查结果只读弹窗
            reviewResultDialogVisible: false,
            reviewResultTitles: [],
            reviewResultTableData: [],
            reviewResultBidders: [],
            reviewResultBidSectionName: '',
            reviewResultLoading: false
        }
    },
    computed: {
        selectedUnitLabel() {
            if (!this.selectedUnit) return ''
            const idx = this.unitOptions.findIndex(u => u.id === this.selectedUnit)
            if (idx === -1) return ''
            return `${idx + 1}、${this.unitOptions[idx].reviewName}`
        }
    },
    directives: {
        clickOutside: {
            bind(el, binding) {
                el._clickOutsideHandler = (e) => {
                    if (!el.contains(e.target)) binding.value(e)
                }
                document.addEventListener('click', el._clickOutsideHandler)
            },
            unbind(el) {
                document.removeEventListener('click', el._clickOutsideHandler)
            }
        }
    },
    mounted() {
        this.getProjectInfo()
        this.loadData()
    },
    methods: {

        handleVerifySeal() {
            this.$message.success('盖章验证成功');
        },
        // 资格审查结果
        async handleReviewResult(row) {
            console.log('--------------------------------');
            console.log(row);
            console.log('--------------------------------');
            
            if (!row || !row.stepId || !row.sectionCode) {
                this.$message.error('缺少步骤信息，无法查看审查结果')
                return
            }
            this.stepId = row.stepId
            this.orderNum = row.orderNum
            this.sectionCode = row.sectionCode
           
            this.reviewResultLoading = true
            this.reviewResultTitles = []
            this.reviewResultTableData = []
            this.reviewResultBidders = []
            this.reviewResultDialogVisible = true
            try {
                const res = await getQualificationRecordInfoList({
                    stepId: this.stepId,
                    sectionCode: this.sectionCode,
                    orderNum: this.orderNum,
                })
                if (res && res.code === 200) {
                    const data = res.data || {}
                    
                    this.buildReviewResultTable(data.titles, data.values)
                } else {
                    this.$message.error((res && res.msg) || '获取审查结果失败')
                }
            } catch (err) {
                console.error(err)
                this.$message.error('获取审查结果失败')
            } finally {
                this.reviewResultLoading = false
            }
        },
        // 构建审查结果只读表格（转置：评审项为行，投标公司为列）
        buildReviewResultTable(titles, values) {
            const t = titles || []
            const v = values || []
            const reviewTitles = t.filter(col => col.itemKey !== '0')
            this.reviewResultTitles = reviewTitles
            if (!t.length || !v.length || !reviewTitles.length) {
                this.reviewResultTableData = []
                this.reviewResultBidders = []
                return
            }
            // 提取投标公司列表（按出现顺序去重）
            const nameKey = '0'
            const nameColumns = v.filter(colValues => Array.isArray(colValues) && colValues.some(c => c.itemKey === nameKey))
            const bestNameColumn = nameColumns
                .map(colValues => {
                    const validNameCount = colValues.filter(c => c && c.itemKey === nameKey && c.userId && c.value !== null && c.value !== '').length
                    return {
                        colValues,
                        validNameCount,
                        totalCount: colValues.length
                    }
                })
                .sort((a, b) => {
                    if (b.validNameCount !== a.validNameCount) {
                        return b.validNameCount - a.validNameCount
                    }
                    return b.totalCount - a.totalCount
                })[0]
            const bidders = []
            const userMap = {}
            if (bestNameColumn && Array.isArray(bestNameColumn.colValues)) {
                bestNameColumn.colValues.forEach(c => {
                    if (!c || !c.userId) return
                    if (userMap[c.userId]) return
                    userMap[c.userId] = true
                    bidders.push({
                        userId: c.userId,
                        userName: (c.value !== undefined && c.value !== null) ? c.value : ''
                    })
                })
            }
            this.reviewResultBidders = bidders
            // 按评审项构建行：每行包含每个投标单位的 √/× 和不通过理由
            const rows = reviewTitles.map(col => {
                const row = {
                    _reviewId: col.itemKey,
                    _reviewTitle: col.title || '',
                    _reviewStandard: col.reviewStandard || ''
                }
                // 找到该评审项对应的列数据
                const colValues = v.find(arr => Array.isArray(arr) && arr.some(c => c && c.itemKey === col.itemKey))
                if (Array.isArray(colValues)) {
                    bidders.forEach(b => {
                        const cell = colValues.find(c => c && c.userId === b.userId && c.itemKey === col.itemKey)
                        if (cell) {
                            row[b.userId] = (cell.value !== undefined && cell.value !== null) ? cell.value : ''
                            row[b.userId + '_notPassReason'] = cell.notPassReason || ''
                        } else {
                            row[b.userId] = ''
                            row[b.userId + '_notPassReason'] = ''
                        }
                    })
                }
                return row
            })
            this.reviewResultTableData = rows
        },
        // 关闭审查结果弹窗
        handleReviewResultDialogClose() {
            this.reviewResultDialogVisible = false
        },
        // 打印审查结果
        handlePrintReviewResult() {
            const bidders = this.reviewResultBidders || []
            const rows = this.reviewResultTableData || []
            const projectTitle = this.projectTitle || ''
            const bidSectionName = this.reviewResultBidSectionName || ''
            if (!rows.length) {
                this.$message.warning('暂无审查结果数据可打印')
                return
            }
            const bidderCount = bidders.length
            const escapeHtml = (s) => {
                if (s === undefined || s === null) return ''
                return String(s)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;')
                    .replace(/\n/g, '<br/>')
            }
            const renderMark = (val) => {
                if (val === '1' || val === 1) return { symbol: '√', cls: 'pass' }
                if (val === '0' || val === 0) return { symbol: '×', cls: 'fail' }
                return { symbol: '-', cls: 'empty' }
            }
            const bidderHeader = bidders.map((b, i) => {
                const name = escapeHtml(b.userName)
                return `<th class="bidder-col">${i + 1}. ${name}</th>`
            }).join('')
            const bodyRows = rows.map((row, idx) => {
                const title = escapeHtml(row._reviewTitle || '')
                const standard = escapeHtml(row._reviewStandard || '')
                const idxCell = `<td class="idx-cell">${idx + 1}</td>`
                const titleCell = `<td class="review-cell"><div class="review-name">${title}</div>${standard ? `<div class="review-standard">${standard}</div>` : ''}</td>`
                const cells = bidders.map(b => {
                    const m = renderMark(row[b.userId])
                    const reason = escapeHtml(row[b.userId + '_notPassReason'] || '')
                    return `<td><div class="mark ${m.cls}">${m.symbol}</div>${reason ? `<div class="reason">${reason}</div>` : ''}</td>`
                }).join('')
                return `<tr>${idxCell}${titleCell}${cells}</tr>`
            }).join('')
            const printHtml = `<div class="print-header"><h1>资格审查结果汇总表</h1><div class="info"><div><span class="label">项目名称：</span><span>${escapeHtml(projectTitle)}</span></div><div><span class="label">标段名称：</span><span>${escapeHtml(bidSectionName)}</span></div></div></div><table class="print-table"><thead><tr><th class="idx-col">序号</th><th class="review-col">评审项</th>${bidderHeader}</tr></thead><tbody>${bodyRows}</tbody></table>`
            const printWindow = window.open('', '_blank', 'width=' + Math.max(1200, 260 + bidderCount * 160) + ',height=900')
            if (!printWindow) {
                this.$message.error('浏览器拦截了新窗口，请允许弹窗后再试')
                return
            }
            const doc = printWindow.document
            doc.open()
            doc.write(`<!DOCTYPE html><html><head><meta charset="utf-8" /><title>资格审查结果</title>
                <style>
                    @page { size: A3 landscape; margin: 12mm; }
                    * { box-sizing: border-box; }
                    html, body { margin: 0; padding: 0; background: #ffffff; color: #303133;
                        font-family: "Microsoft YaHei", "PingFang SC", Arial, sans-serif; }
                    body { padding: 16px; }
                    .print-header { margin-bottom: 14px; padding-bottom: 10px; border-bottom: 2px solid #303133; }
                    .print-header h1 { font-size: 22px; font-weight: 700; margin: 0 0 10px; text-align: center; color: #111827; }
                    .print-header .info { font-size: 13px; line-height: 1.8; color: #303133; }
                    .print-header .info .label { font-weight: 600; margin-right: 4px; }
                    table.print-table { width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 12px; }
                    table.print-table th, table.print-table td { border: 1px solid #303133; padding: 8px 6px; text-align: center; vertical-align: middle; word-break: break-all; word-wrap: break-word; overflow-wrap: break-word; }
                    table.print-table thead th { background: #f5f7fa; font-weight: 700; font-size: 12px; }
                    table.print-table th.idx-col { width: 50px; }
                    table.print-table td.idx-cell { width: 50px; text-align: center; font-weight: 600; color: #111827; }
                    table.print-table th.review-col, table.print-table td.review-cell { width: 200px; text-align: left; }
                    table.print-table th.bidder-col { width: 140px; }
                    table.print-table td.review-cell .review-name { font-weight: 600; color: #111827; word-break: break-all; }
                    table.print-table td.review-cell .review-standard { margin-top: 4px; font-size: 11px; color: #6b7280; line-height: 1.5; word-break: break-all; }
                    table.print-table td .mark { font-size: 18px; font-weight: 700; line-height: 1; }
                    table.print-table td .mark.pass { color: #16a34a; }
                    table.print-table td .mark.fail { color: #dc2626; }
                    table.print-table td .mark.empty { color: #c0c4cc; }
                    table.print-table td .reason { margin-top: 4px; font-size: 11px; color: #4b5563; line-height: 1.5; text-align: left; white-space: pre-wrap; word-break: break-all; }
                    table.print-table tbody tr { page-break-inside: avoid; }
                    @media print {
                        body { padding: 0; }
                    }
                </style>
                </head><body>${printHtml}</body></html>`)
            doc.close()
            printWindow.addEventListener('load', () => {
                setTimeout(() => {
                    printWindow.focus()
                    printWindow.print()
                }, 200)
            })
            // 兜底：某些情况下 load 事件可能不触发
            setTimeout(() => {
                try {
                    printWindow.focus()
                    printWindow.print()
                } catch (e) { /* noop */ }
            }, 800)
        },




        /**
         * 获取项目信息
         */
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
        },
        /**
      * 获取标段列表
      */
        loadData() {
            this.loading = true
            qualificationReviewList({
                projectCode: this.projectCode,
                bidSectionName: this.searchForm.bidSectionName,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
                stage: 0
            }).then(res => {
                if (res.code === 200) {
                    const data = res.data
                    this.tableData = data.records.map((item, index) => ({
                        no: (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1,
                        bidSectionCode: item.bidSectionCode,
                        bidSectionName: item.bidSectionName,
                        status: item.status
                    }))
                    this.pagination.total = data.total
                }
            }).catch(err => {
                this.$message.error('获取标段列表失败');
                console.error(err);
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * 获取甲方代表资格审查
         */
        getAgentReview(bidSectionCode) {
            this.dialogLoading = true
            getAgentReview({ sectionCode: bidSectionCode }).then(res => {
                if (res.code === 200) {
                    this.reviewList = res.data || []
                } else {
                    this.$message.error(res.msg || '获取审查列表失败')
                }
            }).catch(err => {
                this.$message.error('获取审查列表失败')
                console.error(err)
            }).finally(() => {
                this.dialogLoading = false
            })
        },

        /**
     * 开始审查
     */
        handleStartReview(row) {
            this.stepId = row.stepId
            this.orderNum = row.orderNum
            this.sectionCode = row.sectionCode
            this.getBidderList(row)
            this.getStepDetailByStepId(row.stepId)
        },
        //  获取投标人列表
        getBidderList(row) {
            const params = { stepId: row.stepId, sectionCode: this.sectionCode }
            getBidderList(params).then(res => {
                if (res.code === 200) {
                    this.drawer = true
                    this.bidderOptions = res.data
                    if (res.data.length > 0) {
                        const firstUserId = res.data[0].userId
                        this.selectedBidder = firstUserId
                        this.getBidderFile(firstUserId)
                    } else {
                        this.$message.error("投标单位列表为空")
                    }
                }
            })
        },
        // 获取投标正文
        getBidderFile(userId) {
            const params = { userId: userId, sectionCode: this.sectionCode }
            getBidderFile(params).then(res => {
                if (res.code === 200) {
                    this.pdfUrl = res.data
                    console.log(this.pdfUrl);
                } else {
                    this.$message.error(res.msg || '获取投标正文失败')
                }
            })
        },
        // 获取步骤详情
        getStepDetailByStepId(stepId) {
            getStepDetailByStepId({ stepId }).then(res => {
                if (res.code === 200) {
                    this.unitOptions = Array.isArray(res.data.itemList) ? res.data.itemList : []
                    const firstItem = this.unitOptions[0]
                    const firstId = firstItem ? firstItem.id : ''
                    if (firstId) {
                        this.selectedUnit = firstId
                        this.reviewStandard = firstItem.reviewStandard
                        this.nodeName = firstItem.stepName || ''
                        this.getQualificationRecordInfo(firstId)
                   
                    }
                } else {
                    this.$message.error(res.msg || '获取步骤详情失败')
                }
            })
        },
        //  获取右侧单位评审
        getQualificationRecordInfo(stepReviewId){
            const params = {
                stepId: this.stepId,
                sectionCode: this.sectionCode,
                orderNum:this.orderNum,
                stepReviewId:stepReviewId,
            }
            getQualificationRecordInfo(params).then(res => {
                if (res.code === 200) {
                    this.next = res.data.next
                    this.previous = res.data.previous
                    this.recordInfo = res.data      
                } else {
                    this.$message.error(res.msg || '获取评审项信息失败')
                }
            })

        },

        // 获取评审生效列表
        getQualificationRecordInfoList() {
            const params = {
                stepId: this.stepId,
                sectionCode: this.sectionCode,
                orderNum: this.orderNum,
            }
            getQualificationRecordInfoList(params).then(res => {
                if (res.code === 200) {
                    const data = res.data || {}
                    this.buildReviewEffectiveTable(data.titles, data.values)
                } else {
                    this.reviewEffectiveTableData = []
                    this.reviewEffectiveTitles = []
                    this.$message.error(res.msg || '获取评审生效列表失败')
                }
            })
        },

        // 选择评审项
        selectUnit(unit, index) {
            this.selectedUnit = unit.id
            this.unitSelectOpen = false
            this.reviewStandard = unit.reviewStandard || ''
            this.getQualificationRecordInfo(unit.id)
        },
        // 点击 √ 或 × 时处理
        handleIsPassChange(item) {
            console.log('评审结果变更', item)
        },
        // 不通过原因输入处理
        handleNotPassReasonInput(item) {
            console.log('不通过原因输入', item)
        },
        // 一键通过
        handleOneClickPass() {
            (this.recordInfo.userItems || []).forEach(item => {
                item.isPass = 1
                item.notPassReason = ''
            })
            this.$message.success('已设置当前评审项全部为通过')
        },
        // 步骤导航
        handleStepItemNavigate(targetStepId) {
            if (!targetStepId) {
                return
            }
            this.saveQualificationRecordPassPerAction(targetStepId)
        },
        // 保存评审结果
        saveQualificationRecordPassPerAction(nextStepReviewId) {
            if (!this.validateCurrentPassCompleted()) {
                return
            }
            const list = (this.recordInfo.userItems || []).map(item => {
                let isPassVal = item.isPass
                if (isPassVal === true) isPassVal = 1
                if (isPassVal === false || isPassVal === undefined || isPassVal === null || isPassVal === '') isPassVal = 0
                if (isPassVal === '1') isPassVal = 1
                if (isPassVal === '0') isPassVal = 0
                return {
                    isPass: Number(isPassVal) || 0,
                    notPassReason: item.notPassReason || '',
                    userId: item.userId,
                    userName: item.userName
                }
            })
            saveQualificationRecordPassPer({
                list: list,
                stepId: this.stepId,
                stepReviewId: this.selectedUnit,
                sectionCode: this.sectionCode,
                orderNum: this.orderNum
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success(res.msg)
                    if (nextStepReviewId) {
                        // 切换到下一个评审项
                        const nextUnit = this.unitOptions.find(u => u.id === nextStepReviewId)
                        if (nextUnit) {
                            this.selectedUnit = nextUnit.id
                            this.reviewStandard = nextUnit.reviewStandard || ''
                        }
                        this.getQualificationRecordInfo(nextStepReviewId)
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(error => {
                this.$message.error('保存评审结果失败')
            })
        },
        // 校验当前通过式评审是否都完成
        validateCurrentPassCompleted() {
            for (const item of (this.recordInfo.userItems || [])) {
                const val = item.isPass
                if (val === undefined || val === null || val === '') {
                    this.$message.error('请完成所有用户的评审')
                    return false
                }
                if (val === 0 || val === '0' || val === false) {
                    const reason = item.notPassReason
                    if (!reason || !reason.trim()) {
                        this.$message.error('不通过的评审项请填写评审意见')
                        return false
                    }
                }
            }
            return true
        },
        // 提交
        submit() {
            if (!this.validateCurrentPassCompleted()) {
                return
            }
            this.saveQualificationRecordPassPerAction(this.selectedUnit)
            const list = (this.recordInfo.userItems || []).map(item => {
                let isPassVal = item.isPass
                if (isPassVal === true) isPassVal = 1
                if (isPassVal === false || isPassVal === undefined || isPassVal === null || isPassVal === '') isPassVal = 0
                if (isPassVal === '1') isPassVal = 1
                if (isPassVal === '0') isPassVal = 0
                return {
                    isPass: Number(isPassVal) || 0,
                    notPassReason: item.notPassReason || '',
                    userId: item.userId,
                    userName: item.userName
                }
            })
            submitQualificationRecord({
                list: list,
                stepId: this.stepId,
                stepReviewId: this.selectedUnit,
                sectionCode: this.sectionCode,
                orderNum: this.orderNum
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success(res.msg)
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(error => {
                this.$message.error('提交评审结果失败')
            })
        },
        handleSetQualification(row) {
            this.dialogVisible = true
            this.reviewResultBidSectionName = row.bidSectionName || ''
            this.getAgentReview(row.bidSectionCode)
        },
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },

        handleReset() {
            this.searchForm.bidSectionName = ''
            this.pagination.currentPage = 1
            this.loadData()
        },


        handleBack() {
            this.$router.go(-1)
        },


        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        handleClose() {
            this.drawer = false
        },
        handleBidderChange(val) {
            this.selectedBidder = val
            this.getBidderFile(val)
        },
        handleReviewEffective() {
            this.getQualificationRecordInfoList()
            this.effectiveActiveColumnKey = ''
            this.effectiveActiveItemId = ''
            this.effectiveReviewStandard = ''
            this.reviewEffectiveDialogVisible = true
        },
        openAttachmentViewByUserId(userId) {
            if (!userId) {
                this.$message.warning('请先选择投标单位')
                return
            }
            this.attachmentViewList = []
            this.attachmentViewDialogVisible = true
            getBidderAttachment({
                sectionCode: this.sectionCode,
                userId
            }).then(res => {
                if (res.code === 200) {
                    this.attachmentViewList = Array.isArray(res.data) ? res.data : []
                } else {
                    this.$message.error(res.msg || '获取附件列表失败')
                }
            }).catch(error => {
                console.error('获取附件列表失败:', error)
                this.$message.error('获取附件列表失败')
            })
        },
        // 下载附件文件
        handleFileDownload(file) {
            if (!file || !file.fileUrl) {
                this.$message.warning('文件链接不存在')
                return
            }
            const link = document.createElement('a')
            link.href = file.fileUrl
            link.download = file.fileName
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        // 构建评审生效表格
        buildReviewEffectiveTable(titles, values) {
            const t = titles || []
            const v = values || []
            this.reviewEffectiveTitles = t
            if (!t.length || !v.length) {
                this.reviewEffectiveTableData = []
                return
            }
            const userMap = {}
            v.forEach(colValues => {
                if (!Array.isArray(colValues)) return
                colValues.forEach(cell => {
                    if (!cell || !cell.userId) return
                    const uid = cell.userId
                    if (!userMap[uid]) {
                        userMap[uid] = { _userId: uid }
                    }
                    const row = userMap[uid]
                    const key = cell.itemKey
                    if (typeof key !== 'undefined') {
                        row[key] = (cell.value !== undefined && cell.value !== null) ? cell.value : ''
                        if (typeof cell.notPassReason !== 'undefined' && cell.notPassReason !== null) {
                            row[key + '_notPassReason'] = cell.notPassReason
                        }
                        if (typeof cell.scoreReason !== 'undefined' && cell.scoreReason !== null) {
                            row[key + '_reason'] = cell.scoreReason
                            if (cell.scoreReason !== '') {
                                row[key + '_needReason'] = true
                            }
                        }
                        if (key === '0') {
                            row._userName = (cell.value !== undefined && cell.value !== null) ? cell.value : ''
                            if (!Object.prototype.hasOwnProperty.call(row, '0')) row['0'] = ''
                        }
                    }
                })
            })
            const nameKey = '0'
            let rows = Object.values(userMap)
            if (t.some(tt => tt.itemKey === nameKey)) {
                const nameColumns = v.filter(colValues => Array.isArray(colValues) && colValues.some(c => c.itemKey === nameKey))
                const bestNameColumn = nameColumns
                    .map(colValues => {
                        const validNameCount = colValues.filter(c => c && c.itemKey === nameKey && c.userId && c.value !== null && c.value !== '').length
                        return {
                            colValues,
                            validNameCount,
                            totalCount: colValues.length
                        }
                    })
                    .sort((a, b) => {
                        if (b.validNameCount !== a.validNameCount) {
                            return b.validNameCount - a.validNameCount
                        }
                        return b.totalCount - a.totalCount
                    })[0]
                if (bestNameColumn && Array.isArray(bestNameColumn.colValues)) {
                    const orderedUserIds = bestNameColumn.colValues.map(c => c.userId)
                    rows = orderedUserIds
                        .filter((uid, idx) => !!uid && orderedUserIds.indexOf(uid) === idx)
                        .map(uid => userMap[uid])
                        .filter(r => !!r)
                }
            }
            rows.forEach(row => {
                t.forEach(col => {
                    if (col.itemKey === '0') return
                    const k = col.itemKey
                    if (!Object.prototype.hasOwnProperty.call(row, k)) row[k] = ''
                    if (!Object.prototype.hasOwnProperty.call(row, k + '_reason')) row[k + '_reason'] = ''
                    if (!Object.prototype.hasOwnProperty.call(row, k + '_notPassReason')) row[k + '_notPassReason'] = ''
                    if (!Object.prototype.hasOwnProperty.call(row, k + '_needReason')) row[k + '_needReason'] = false
                    if (!Object.prototype.hasOwnProperty.call(row, k + '_scoreError')) row[k + '_scoreError'] = ''
                })
            })
            this.reviewEffectiveTableData = rows
        },
        getEffectiveColumnItemId(col) {
            if (!col) {
                return ''
            }
            return col.stepReviewId || col.stepScoreId || col.id || ''
        },
        // 评审生效弹窗：通过式 √/× 点击立即保存
        handleEffectiveIsPassChange(row, col) {
            if (!row || !col) return
            this._effectiveDebounceTimer && clearTimeout(this._effectiveDebounceTimer)
            this.saveEffectiveSingleReview(row, col)
        },
        // 评审生效弹窗：通过式理由输入防抖保存
        handleEffectiveReasonInput(row, col) {
            if (!row || !col) return
            if (this._effectiveDebounceTimer) clearTimeout(this._effectiveDebounceTimer)
            this._effectiveDebounceTimer = setTimeout(() => {
                this.saveEffectiveSingleReview(row, col)
                this._effectiveDebounceTimer = null
            }, 600)
        },
        // 评审生效弹窗：保存单条通过式评审记录
        saveEffectiveSingleReview(row, col) {
            if (!row || !col) return
            const userId = row['_userId']
            const userName = row['0']
            if (!userId && !userName) return
            let isPassVal = row[col.itemKey]
            if (isPassVal === true) isPassVal = 1
            if (isPassVal === false || isPassVal === undefined || isPassVal === null || isPassVal === '') isPassVal = 0
            if (isPassVal === '1') isPassVal = 1
            if (isPassVal === '0') isPassVal = 0
            saveQualificationRecordPassPer({
                sectionCode: this.sectionCode,
                stepId: this.stepId,
                stepReviewId: col.stepReviewId,
                isPass: Number(isPassVal) || 0,
                notPassReason: row[col.itemKey + '_notPassReason'] || '',
                userId: userId,
                userName: userName || '',
                orderNum: this.orderNum
            }).catch(() => { })
        },
        // 一键通过（弹窗内）
        handleOneClickPassInDialog() {
            const userIdKey = '_userId'
            const userNameKey = '0'
            const reviewCols = (this.reviewEffectiveTitles || []).filter(col => {
                return col.itemKey !== userIdKey && col.itemKey !== userNameKey && col.stepReviewId
            })
            ; (this.reviewEffectiveTableData || []).forEach(row => {
                const hasUser = row[userIdKey] || row[userNameKey]
                if (!hasUser) return
                reviewCols.forEach(col => {
                    row[col.itemKey] = '1'
                    row[col.itemKey + '_notPassReason'] = ''
                })
            })
            this.$message.success('已设置所有评审项为通过')
        },
        // 提交生效
        handleSubmitEffective() {
            if (!this.validateAllEffectiveCompleted()) {
                return
            }
            this.saveQualificationRecordPassAll()
        },
        // 校验评审生效弹窗中所有人是否都完成了评审
        validateAllEffectiveCompleted() {
            const userIdKey = '_userId'
            const userNameKey = '0'
            const reviewCols = (this.reviewEffectiveTitles || []).filter(col => {
                return col.itemKey !== userIdKey && col.itemKey !== userNameKey && col.stepReviewId
            })

            for (const row of (this.reviewEffectiveTableData || [])) {
                for (const col of reviewCols) {
                    const val = row[col.itemKey]
                    if (val === undefined || val === null || val === '') {
                        this.$message.error('请完成所有评审项的评审')
                        return false
                    }
                    if (val === 0 || val === '0' || val === false) {
                        const reason = row[col.itemKey + '_notPassReason']
                        if (!reason || !reason.trim()) {
                            this.$message.error('不通过的评审项请填写评审意见')
                            return false
                        }
                    }
                }
            }
            return true
        },
        // 保存所有通过式评审结果（评审生效）
        saveQualificationRecordPassAll() {
            const userIdKey = '_userId'
            const userNameKey = '0'
            const reviewCols = (this.reviewEffectiveTitles || []).filter(col => {
                return col.itemKey !== userIdKey && col.itemKey !== userNameKey && col.stepReviewId
            })
            // 使用 Map 进行去重，按 userId + stepReviewId 组合
            const listMap = new Map();
            (this.reviewEffectiveTableData || []).forEach(row => {
                const userId = row[userIdKey]
                const userName = row[userNameKey]
                if (!userId && !userName) return
                reviewCols.forEach(col => {
                    const key = `${userId}_${col.stepReviewId}`
                    if (listMap.has(key)) return // 已存在则跳过
                    let isPassVal = row[col.itemKey]
                    if (isPassVal === true) isPassVal = 1
                    if (isPassVal === false || isPassVal === undefined || isPassVal === null || isPassVal === '') isPassVal = 0
                    if (isPassVal === '1') isPassVal = 1
                    if (isPassVal === '0') isPassVal = 0
                    listMap.set(key, {
                        stepReviewId: col.stepReviewId,
                        userId: userId,
                        userName: userName,
                        isPass: Number(isPassVal) || 0,
                        notPassReason: row[col.itemKey + '_notPassReason'] || ''
                    })
                })
            })
            const list = Array.from(listMap.values())
            let params = {
                list: list,
                stepId: this.stepId,
                sectionCode: this.sectionCode,
                orderNum: this.orderNum,
            }
            console.log('提交评审生效数据:', params)
            return saveQualificationRecordPassAll(params).then(res => {
                if (res.code === 200) {
                    this.$message.success('评审结果已提交生效')
                    this.reviewEffectiveDialogVisible = false
                    this.getStepDetailByStepId(this.stepId)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 关闭评审生效弹窗
        handleReviewEffectiveDialogClose(done) {
            this.reviewEffectiveDialogVisible = false
            this.effectiveReviewStandard = ''
            this.effectiveActiveColumnKey = ''
            this.effectiveActiveItemId = ''
            if (typeof done === 'function') {
                done()
            }
        },
    }
}</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

.drawer-content {
    flex: 1;
    width: 100vw;
    height: 100vh;

    .top-navbar {
        height: 60px;
        background-color: #e6f7ff;
        display: flex;
        align-items: center;
        justify-content: end;
        padding: 0 20px;
        border-bottom: 1px solid #d9d9d9;

        .navbar-left {
            margin: 0px auto;
        }


    }

    .review-area {
        width: 25%;
        background-color: white;
        border-left: 1px solid #e4e7ed;
        padding: 20px;
        overflow-y: auto;
    }
}

/* 评审项选择样式 */
.qualification-review {
    .review-header {
        margin-bottom: 20px;

        h3 {
            font-size: 16px;
            font-weight: bold;
            color: #333;
            margin: 0;
        }
    }
}

.review-fixed-section {
    flex: 0 0 auto;
}

.unit-selection {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    background-color: #f9f9f9;

    .selection-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 15px;
    }
}

/* 自定义评审项下拉 */
.unit-select-custom {
    position: relative;
    width: 100%;
}

.usc-trigger {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    min-height: 36px;
    padding: 6px 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.2s;
    gap: 6px;

    &:hover {
        border-color: #c0c4cc;
    }

    &.is-open {
        border-color: #409eff;
    }

    .usc-value {
        flex: 1;
        font-size: 14px;
        color: #606266;
        line-height: 1.6;
        word-break: break-all;
        white-space: normal;
    }

    .usc-placeholder {
        flex: 1;
        font-size: 14px;
        color: #c0c4cc;
        line-height: 1.6;
    }

    .usc-arrow {
        flex-shrink: 0;
        font-size: 14px;
        color: #c0c4cc;
        margin-top: 3px;
        transition: transform 0.3s;

        &.is-open {
            transform: rotate(180deg);
        }
    }
}

.usc-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 2000;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    max-height: 280px;
    overflow-y: auto;
}

.usc-option {
    padding: 8px 12px;
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
    word-break: break-all;
    white-space: normal;
    cursor: pointer;

    &:hover {
        background: #f5f7fa;
    }

    &.is-selected {
        color: #409eff;
        font-weight: 500;
        background: #f0f7ff;
    }
}

.usc-empty {
    padding: 10px 12px;
    font-size: 14px;
    color: #c0c4cc;
    text-align: center;
}

/* 评审标准区域 */
.review-standard-box {
    margin: 12px 0 20px;
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    background-color: #f9fafc;
    display: flex;
    align-items: flex-start;
    font-size: 13px;
    color: #606266;
}

.review-standard-title {
    flex: 0 0 auto;
    font-weight: 600;
    color: #303133;
    margin-right: 8px;
}

.review-standard-content {
    flex: 1 1 auto;
    line-height: 1.6;
    word-break: break-all;
    text-align: start;
}

/* 评审滚动区域 */
.review-scroll-section {
    max-height: calc(100vh - 400px);
    overflow-y: auto;
}

.review-scroll-section::-webkit-scrollbar {
    width: 6px;
}

.review-scroll-section::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;
}

.review-scroll-section::-webkit-scrollbar-track {
    background: transparent;
}

/* 评审项样式 */
.review-item {
    margin-bottom: 30px;
    padding: 22px;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
}

.review-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.item-label {
    font-size: 14px;
    font-weight: bold;
    color: #333;
}

.review-options {
    margin-bottom: 15px;
}

.review-options .el-radio-group {
    display: flex;
    gap: 20px;
}

.review-options .el-radio {
    margin-right: 0;
}

.radio-label {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.comment-area {
    margin-top: 10px;
}

.comment-area .el-textarea__inner {
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    font-size: 14px;
    line-height: 1.5;
}

.comment-area .el-textarea__inner:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 操作按钮 */
.action-buttons {
    flex: 0 0 auto;
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
    background-color: #fff;
}

.action-buttons .el-button {
    padding: 10px 20px;
    font-size: 14px;
}

/* 评审生效弹窗样式 */
.review-effective-dialog .el-dialog {
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
    max-height: none !important;
    border-radius: 0 !important;
}

.review-effective-dialog .el-dialog__header {
    display: none;
}

.review-effective-dialog .el-dialog__body {
    padding: 0 !important;
    height: 100vh;
    overflow: hidden;
}

.review-effective-content {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: linear-gradient(180deg, #f4f7fb 0%, #eef3f9 100%);
}

.review-effective-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 24px;
    border-bottom: 1px solid #e5e7eb;
    background: rgba(255, 255, 255, 0.94);
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
    gap: 16px;
}

.header-left {
    min-width: 0;
}

.review-title {
    font-size: 26px;
    font-weight: 700;
    color: #111827;
    margin: 0;
}

.review-effective-subtitle {
    margin-top: 6px;
    font-size: 13px;
    line-height: 1.6;
    color: #6b7280;
}

.header-right {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.one-click-pass-btn,
.close-btn,
.submit-effective-btn {
    padding: 10px 18px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
}

.one-click-pass-btn,
.submit-effective-btn {
    background: linear-gradient(135deg, #409eff 0%, #2563eb 100%);
    border-color: #409eff;
    color: white;
    box-shadow: 0 10px 20px rgba(37, 99, 235, 0.18);
}

.close-btn {
    background: #ffffff;
    border-color: #d1d5db;
    color: #374151;
}

.one-click-pass-btn:hover,
.submit-effective-btn:hover {
    background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
    border-color: #60a5fa;
    color: white;
}

.close-btn:hover {
    background: #f9fafb;
    border-color: #9ca3af;
    color: #111827;
}

.review-table-container {
    flex: 1;
    padding: 20px 24px 24px;
    overflow: auto;
}

.effective-review-standard {
    margin-bottom: 16px;
    padding: 16px 18px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #f8fbff;
}

.effective-review-standard-title {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.effective-review-standard-content {
    font-size: 14px;
    line-height: 22px;
    color: #606266;
    white-space: pre-wrap;
    word-break: break-word;
}

.review-effective-table {
    background: #ffffff;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
}

.review-effective-table ::v-deep .el-table__header-wrapper th {
    background: linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%) !important;
    color: #374151 !important;
    font-size: 13px;
    font-weight: 700 !important;
    border-bottom: 1px solid #e5e7eb;
}

.review-effective-table ::v-deep .el-table__body tr>td {
    padding: 14px 10px;
    border-bottom: 1px solid #eef2f7;
    vertical-align: top;
}

.review-effective-table ::v-deep .el-table__body tr:hover>td {
    background: #f8fbff !important;
}

.review-effective-table ::v-deep .cell {
    padding-left: 8px;
    padding-right: 8px;
}

.review-effective-table .el-radio-group {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
}

.review-effective-table .el-radio {
    margin-right: 0;
}

.review-effective-table ::v-deep .el-radio {
    margin-right: 0;
    padding: 8px 14px;
    border: 1px solid #dbe3ef;
    border-radius: 10px;
    background: #ffffff;
    transition: all 0.2s ease;
}

.review-effective-table ::v-deep .el-radio:hover {
    border-color: #93c5fd;
    background: #f8fbff;
}

.review-effective-table ::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #2563eb;
}

.review-effective-table ::v-deep .el-radio__inner {
    border-color: #cbd5e1;
}

.review-effective-table ::v-deep .el-radio__input.is-checked .el-radio__inner {
    background: #2563eb;
    border-color: #2563eb;
}

.review-effective-table ::v-deep .el-radio.is-checked {
    border-color: #93c5fd;
    background: #eff6ff;
    box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);
}

.review-effective-table .el-radio__label {
    font-size: 15px;
    font-weight: 700;
    color: #374151;
}

.effective-reason-input {
    margin-top: 10px;
}

.effective-reason-input ::v-deep .el-textarea__inner {
    background: #fbfdff;
    border-radius: 12px;
    border-color: #d1d5db;
    min-height: 82px;
    line-height: 1.6;
    padding: 10px 12px;
}

.effective-reason-input ::v-deep .el-textarea__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
}

.cell-comment {
    margin-top: 10px;
    text-align: left;
}

.effective-unit-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.unit-name {
    font-size: 14px;
    color: #303133;
    text-align: center;
    line-height: 1.4;
}

/* 资格审查结果弹窗样式 */
.review-result-dialog .el-dialog__body {
    padding: 0 !important;
}

.review-result-content {
    background: linear-gradient(180deg, #f4f7fb 0%, #eef3f9 100%);
    min-height: 80vh;
}

.review-result-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 24px;
    border-bottom: 1px solid #e5e7eb;
    background: rgba(255, 255, 255, 0.94);
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
    gap: 16px;
}

.review-result-title {
    font-size: 22px;
    font-weight: 700;
    color: #111827;
    margin: 0;
}

.review-result-subtitle {
    margin-top: 6px;
    font-size: 13px;
    line-height: 1.6;
    color: #6b7280;
}

.print-btn,
.close-btn {
    padding: 10px 18px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
}

.print-btn {
    background: linear-gradient(135deg, #409eff 0%, #2563eb 100%);
    border-color: #409eff;
    color: white;
    box-shadow: 0 10px 20px rgba(37, 99, 235, 0.18);
}

.close-btn {
    background: #ffffff;
    border-color: #d1d5db;
    color: #374151;
}

.print-btn:hover {
    background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
    border-color: #60a5fa;
    color: white;
}

.close-btn:hover {
    background: #f9fafb;
    border-color: #9ca3af;
    color: #111827;
}

.review-result-print-area {
    padding: 24px;
}

.print-header {
    margin-bottom: 18px;
    padding-bottom: 14px;
    border-bottom: 2px solid #303133;
}

.print-header h1 {
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 12px;
    text-align: center;
    color: #111827;
}

.print-header .info {
    font-size: 14px;
    line-height: 1.8;
    color: #303133;
}

.print-header .info .label {
    font-weight: 600;
    margin-right: 4px;
}

.review-result-table {
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
}

.review-result-table ::v-deep .el-table__header-wrapper th {
    background: linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%) !important;
    color: #374151 !important;
    font-size: 13px;
    font-weight: 700 !important;
    border-bottom: 1px solid #e5e7eb;
}

.review-result-table ::v-deep .el-table__body tr>td {
    padding: 14px 10px;
    border-bottom: 1px solid #eef2f7;
    vertical-align: middle;
}

.review-result-table ::v-deep .el-table__body tr:hover>td {
    background: #f8fbff !important;
}

.result-unit-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.result-unit-cell .unit-name {
    font-size: 13px;
    font-weight: 600;
}

.result-review-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    text-align: left;
}

.result-review-cell .review-name {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    line-height: 1.5;
}

.result-review-cell .review-standard-text {
    font-size: 12px;
    color: #6b7280;
    line-height: 1.5;
    word-break: break-all;
    white-space: pre-wrap;
    text-align: left;
    max-width: 240px;
}

.result-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.result-mark {
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
}

.result-mark.pass {
    color: #16a34a;
}

.result-mark.fail {
    color: #dc2626;
}

.result-cell .cell-comment {
    margin-top: 4px;
    text-align: left;
    font-size: 12px;
    color: #6b7280;
    word-break: break-all;
    white-space: pre-wrap;
    max-width: 220px;
    line-height: 1.5;
}

@media print {
    .review-result-dialog .el-dialog__header,
    .review-result-dialog .el-dialog__body {
        padding: 0 !important;
    }
    .review-result-header,
    .el-dialog__wrapper .v-modal {
        display: none !important;
    }
    .review-result-content {
        background: #ffffff !important;
        min-height: auto !important;
    }
    .review-result-print-area {
        padding: 0 !important;
    }
}
</style>
